import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons'
import { Dropdown, Menu } from 'hljd'
import { Flex } from 'hljd'

export default ({ list, max = 3 }) => {
  list = list || []

  const listNode = list.slice(0, max).map((item, index) => {
    return (
      <span key={index} style={{ marginRight: 16 }}>
        {item}
      </span>
    )
  })

  const extra =
    list.length > max ? (
      <Dropdown
        overlay={
          <Menu>
            {list.slice(max).map((item, index) => {
              return <Menu.Item key={index}>{item}</Menu.Item>
            })}
          </Menu>
        }
      >
        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
          <EllipsisOutlined style={{ fontSize: '24px' }} />
        </a>
      </Dropdown>
    ) : null

  return (
    <Flex vc>
      {listNode}

      {extra}
    </Flex>
  )
}
